import Vue from "vue"
import VueI18n from "vue-i18n"
import { readSavedLocale } from "./locale"

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
const dateTimeFormats = {
  pl: {
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
  en: {
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
  sk: {
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
  de: {
    long: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
  },
}

export default new VueI18n({
  locale: readSavedLocale() || process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
  dateTimeFormats: dateTimeFormats,
  pluralizationRules: {
    // Polski: one (1) | few (2-4, poza 12-14) | many (reszta)
    pl: function (choice) {
      if (choice === 1) return 0
      const mod10 = choice % 10
      const mod100 = choice % 100
      if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 1
      return 2
    },
    // Słowacki: one (1) | few (2-4) | other (reszta)
    sk: function (choice) {
      if (choice === 1) return 0
      if (choice >= 2 && choice <= 4) return 1
      return 2
    },
  },
})
